import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop } from 'lodash';
import { SOCIAL_NETWORKS, shareMappingPath } from '../../../../../widget/constants/social-networks';
import { buildUrl } from '../../../../../common/utils/url/build-url';
import { getOrigin } from '../../../../../common/utils/url/get-origin';
import { openPopup } from '../../../../../common/utils/open-popup';
import { getBsi } from '../../../../../common/utils/get-bsi';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import FacebookIcon from '../../../../../icons/compiled/components/FacebookIcon';
export class Facebook extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      const {
        canShareContent
      } = this.props;
      if (canShareContent) {
        const url = this.getShareUrl();
        openPopup(url);
      }
      this.props.onShare(SOCIAL_NETWORKS.FACEBOOK);
    });
  }
  getShareUrl() {
    const {
      instanceInfo,
      videoId,
      channelId
    } = this.props;
    const {
      instanceId,
      componentId,
      sitePageId,
      siteUrl,
      biToken
    } = instanceInfo;
    const baseUrl = getOrigin(siteUrl);
    const shareProxyUrl = buildUrl(`${baseUrl}/${shareMappingPath}/${sitePageId}`, {
      'instance-id': instanceId,
      'component-id': componentId,
      'channel-id': channelId,
      'video-id': videoId,
      'bi-token': biToken,
      bsi: getBsi()
    });
    return buildUrl('https://www.facebook.com/sharer/sharer.php', {
      ref: 'site',
      display: 'popup',
      u: shareProxyUrl
    });
  }
  render() {
    const {
      className,
      ariaLabel,
      dataHook,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.onClick,
      "data-hook": dataHook,
      className: className,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(FacebookIcon, null),
      className: parentStyles.icon
    })));
  }
}
_defineProperty(Facebook, "defaultProps", {
  onShare: noop
});
//# sourceMappingURL=facebook.js.map